import { useEffect, useState } from 'react'

/**
 * navigator.onLine only reports whether a network interface is up, which on warehouse
 * Wi-Fi is routinely true while nothing actually reaches the server. It is a useful
 * hint for the network strip, but it must never gate a scan — the outbox is the real
 * answer to "can I reach the server", and it finds out by trying.
 */
export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine)

  useEffect(() => {
    const goOnline = () => setIsOnline(true)
    const goOffline = () => setIsOnline(false)

    window.addEventListener('online', goOnline)
    window.addEventListener('offline', goOffline)

    return () => {
      window.removeEventListener('online', goOnline)
      window.removeEventListener('offline', goOffline)
    }
  }, [])

  return isOnline
}
